import React from 'react'
import { Table, Spinner } from 'react-bootstrap'
import './SearchResultsTable.css'

type xpertDirector = {
  firstname?: string
  surname?: string
  idno?: string
  name?: string
  enquiryID?: string
  enquiryResultID?: string
}

type Props = {
  xpertDirectors: xpertDirector[]

  setXpertDirector: (director: xpertDirector) => void
}

const TableDataDirectorEnquiry: React.FC<Props> = ({
  xpertDirectors,
  setXpertDirector,
}) => (
  <div
    className="kyc-director-results-table-container"
    style={{ height: '300px', overflow: 'auto', marginTop: '2rem' }}
  >
    <table>
      <thead>
        <tr>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            Firstname
          </td>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            Surname
          </td>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            Id number
          </td>
        </tr>
      </thead>
      <tbody>
        {xpertDirectors.map((director) => (
          <tr
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setXpertDirector(director)
            }}
          >
            <td>{director.firstname}</td>
            <td>{director.surname}</td>
            <td>{director.idno}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

export default TableDataDirectorEnquiry
